module.exports = {
  commandStack: [ 'type', require(120) ]
};
